import arrowIcon from '@/assets/images/icons/icon-arrow.png';
import homeIcon from '@/assets/images/icons/icon-home.png';
import FaIcon from '@/components/icon/FaIcon/FaIcon';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import type { Route } from 'next';
import Link from 'next/link';
import LoadingLink from '../LoadingLink/LoadingLink';
import styles from './BreadCrumb.module.scss';

function BreadCrumb({
  items,
}: {
  items: { text: string; href?: string }[];
}) {
  return (
    <div className={styles.componentStyle}>
      <LoadingLink href='/'>
        <img src={homeIcon.src} alt='icon' className={styles.homeIcon} />
      </LoadingLink>
      <div className={styles.breadcrumbItems}>
        {items.map((item) => (
          <div key={item.text} className={styles.item}>
            <div className={styles.arrowIcon}>
              <FaIcon icon={faChevronRight} />
            </div>
            {item.href ? <LoadingLink href={item.href as Route}>{item.text}</LoadingLink> : <span>{item.text}</span>}
          </div>
        ))}
      </div>
    </div>
  );
}

export default BreadCrumb;
